import React from "react";
import { CustomReactSelect } from "components";
import { Col, Row } from "reactstrap";

const Filters = (props: any) => {
  const {
    company,
    setCompany,
    companiesOptions,
    brand,
    setBrand,
    brandsOptions,
    product,
    setProduct,
    productsOptions,
    voltage,
    setVoltage,
    voltagesOptions,
    formattedPawns,
    setFormattedPawns,
    setFormattedStatus,
    pawnsOptions,
    setIsEditPawn,
    statusOptions,
    formattedStatus,
  } = props;
  return (
    <div className="mt-4">
      <Row>
        <Col md="6" className="mb-3">
          <CustomReactSelect
            label="Empresa"
            field="company"
            value={company}
            onChange={(field: any, newValue: any) => {
              setCompany(newValue);
            }}
            options={companiesOptions}
          />
        </Col>
        <Col md="6" className="mb-3">
          <CustomReactSelect
            label="Marca"
            field="brand"
            value={brand}
            onChange={(field: any, newValue: any) => {
              setBrand(newValue);
            }}
            options={brandsOptions}
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" className="mb-3">
          <CustomReactSelect
            label="Produto"
            field="product"
            value={product}
            onChange={(field: any, newValue: any) => {
              setProduct(newValue);
            }}
            options={productsOptions}
          />
        </Col>
        <Col md="6" className="mb-3">
          <CustomReactSelect
            label="Voltagem"
            field="voltage"
            value={voltage}
            onChange={(field: any, newValue: any) => {
              setVoltage(newValue);
            }}
            options={voltagesOptions}
          />
        </Col>
      </Row>
      <Row>
        <Col md="6" className="mb-3">
          <CustomReactSelect
            label="Empenhos"
            field="pawns"
            value={formattedPawns}
            onChange={(field: any, newValue: any) => {
              setFormattedPawns(newValue);
              if (newValue.value !== "") {
                setIsEditPawn(true);
              }
            }}
            options={pawnsOptions}
          />
        </Col>
        <Col md="6" className="mb-3">
          <CustomReactSelect
            label="Status"
            field="status"
            value={formattedStatus}
            onChange={(field: any, newValue: any) => {
              setFormattedStatus(newValue);
            }}
            options={statusOptions}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Filters;
